









































import { Vue, Component } from 'vue-property-decorator'

@Component
export default class BlogName extends Vue {
  get codeSnippet1 () {
    return `<html>
  <table id="my-table">
    <tr>
      <td>1</td>
      <td>2</td>
      <td>3</td>
    </tr>
    <tr>
      <td>A</td>
      <td>B</td>
      <td>C</td>
    </tr>
    <tr>
    </tr>
</html>`
  }

  get codeSnippet2 () {
    return `getTableCellCount = (id) => {
  const table = document.getElementById(id)

  let count = 0
  for (let row of table.rows) {
    count += row.cells.length
  }

  return count
}`
  }
}
